import { components } from '@doltech/dto';
import { SkillEnum } from '@doltech/utils/lib/constants';
import { types as t } from 'mobx-state-tree';

import { TestResult } from './test-result.store';
import { Test } from './test.store';
import { ListeningTestSection } from './TestSection/_implementations/listening-test-section.store';
import { ReadingTestSection } from './TestSection/_implementations/reading-test-section.store';

const defaultTestResult: components['schemas']['TestResultDTO'] = {
  correct: 0,
  missed: 0,
  score: 0,
  total: 0,
  wrong: 0,
};

export const UserTest = Test.named('UserTest').props({
  status: t.maybeNull<any>(t.string),
  testType: t.maybeNull<any>(t.string),
  testResults: t.optional(t.maybeNull(TestResult), defaultTestResult),
  testSections: t.optional(
    t.maybeNull(
      t.array(
        t.union(
          {
            dispatcher: (s) => {
              switch (s.skill) {
                case SkillEnum.READING:
                  return ReadingTestSection;
                case SkillEnum.LISTENING:
                  return ListeningTestSection;
                default:
                  throw new Error(`Cannot resolve Test Section skill "${s.skill}"`);
              }
            },
          },
          ReadingTestSection
        )
      )
    ),
    []
  ),
});
